import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../Asset/images/LOGO.png';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/academics', label: 'Academics' },
  { path: '/admissions', label: 'Admissions' },
  { path: '/contact', label: 'Contact' },
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMobileMenu = () => {
    const next = !isMobileMenuOpen;
    setIsMobileMenuOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className={`header${isScrolled ? ' header--scrolled' : ''}`}>
        <div className="header__inner">

          {/* ── Logo ── */}
          <Link to="/" className="logo" aria-label="Star Hacs International School – Home">
            <img src={logo} alt="" className="logo__img" />
            <div className="logo__copy">
              <span className="logo__name">Star Hacs Int. School</span>
              <span className="logo__tagline">Excellence in Education</span>
            </div>
          </Link>

          {/* ── Desktop Nav ── */}
          <nav className="nav" aria-label="Primary navigation">
            <ul className="nav__list">
              {navItems.map(({ path, label }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className={`nav__link${isActive(path) ? ' nav__link--active' : ''}`}
                  >
                    {label}
                    <span className="nav__underline" aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <Link to="/admissions" className="cta-btn" aria-label="Apply now">
              Apply Now
            </Link>
          </nav>

          {/* ── Hamburger ── */}
          <button
            className={`hamburger${isMobileMenuOpen ? ' hamburger--open' : ''}`}
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      {/* ── Mobile Drawer ── */}
      <div
        id="mobile-menu"
        className={`drawer${isMobileMenuOpen ? ' drawer--open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <nav aria-label="Mobile navigation">
          <ul className="drawer__list">
            {navItems.map(({ path, label }, i) => (
              <li key={path} style={{ '--i': i }}>
                <Link
                  to={path}
                  className={`drawer__link${isActive(path) ? ' drawer__link--active' : ''}`}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    document.body.style.overflow = '';
                  }}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <Link
            to="/admissions"
            className="cta-btn cta-btn--block"
            onClick={() => {
              setIsMobileMenuOpen(false);
              document.body.style.overflow = '';
            }}
          >
            Apply Now
          </Link>
        </nav>

        <footer className="drawer__footer">
          <p className="drawer__school">Star Hacs International School</p>
          <p className="drawer__motto">Nurturing Future Leaders</p>
        </footer>
      </div>

      {/* ── Overlay ── */}
      {isMobileMenuOpen && (
        <div
          className="overlay"
          onClick={() => {
            setIsMobileMenuOpen(false);
            document.body.style.overflow = '';
          }}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Header;